<template>
  <tbody>
    <tr class="text-xs-center" v-for="(item, i) in items" :key="i">
      <td class="text-xs-left">
        {{ item.name }}
        <small>Cuenta: {{item.account}}{{item.fiscal_id ? ` - RUT: ${item.fiscal_id}` : ''}}</small>
      </td>
      <td class="text-xs-left">
        {{ item.due_date ? formatedDate(item.due_date, 'YYYY-MM-DD', 'DD/MM/YYYY') : '(Vacio)' }}
        <small>{{item.delinquency ? `Mora: ${item.delinquency}` : 'Sin mora'}}</small>
      </td>
      <td class="text-xs-right">
        <span class="f1-1em">$ {{new Intl.NumberFormat('es-VE').format(item.invoiced_balance)}}</span>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';

export default {
  props: ['items'],
  methods: {
    formatedDate(date, typeFormat, toFormat) {
      return moment(date, typeFormat).format(toFormat);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/global/report_datatables/CustomerStatusList.vue